import 'lazysizes';
import objectFitImages from 'object-fit-images';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lgVideo from 'lightgallery/plugins/video'


import './sentry';
import './notices';
import './dialog';
import './menu';
import './hero';
import './filter';
import './animations';
import './sticky';
import './site-by-brighter';

objectFitImages();

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {

  /**
   * Initialize aria visibility toggles.
   *
   * Usage:
   *    <button aria-expanded="false" aria-controls="myDropdown">Toggle</button>
   *    <div id="myDropdown" aria-hidden="true">Dropdown</div>
   */
  document.querySelectorAll('[aria-expanded][aria-controls]').forEach(el => {
    el.addEventListener('click', e => {
      const id = el.getAttribute('aria-controls');
      const controlled = document.getElementById(id);
      const open = controlled.getAttribute('aria-hidden') !== 'false';

      controlled.setAttribute('aria-hidden', open ? 'false' : 'true');

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach(el => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      e.preventDefault();
    });
  });

  // init light gallery
  if (document.querySelector('.lightgallery')) {
    document.querySelectorAll('.lightgallery').forEach(el => {
      lightGallery(el, {
        plugins: [lgZoom, lgThumbnail, lgVideo],
        speed: 500,
        licenseKey: 'E5D46190-EE13412F-B22CC7F8-29F8C471'
      });
    });
  }

});

document.addEventListener('scroll', function(e) {
  if (window.scrollY > 0) {
    document.querySelector('#main').classList.add('is-scrolled-off-top');
  } else {
    document.querySelector('#main').classList.remove('is-scrolled-off-top');
  }
});

document.querySelectorAll('.block-link').forEach(el => {
  el.addEventListener('click', function(e) {
    el.querySelector('a').click();
  });
});
